export default function () {
  return {
    __noSuchMethod__() {
    },
  };
}
